import {
  FILTERS_BY_GROUPS_IDS as sharedFiltersByGroupsIds,
  FILTERS_GROUPS as sharedFiltersGroups,
  FILTERS_GROUPS_IDS as sharedFiltersGroupsIds
} from '../../common/filtersGroups.js'
import {LISTING_SECTION_IDS} from '../../common/listingSections.js'
import {ALL_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './allVehiclesListingSectionFiltersGroups.js'
import {AUTOCARAVANS_AND_TRAILERS_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './autocaravansAndTrailersVehiclesListingSectionFiltersGroups.js'
import {CLASSIC_AND_COMPETITION_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './classicAndCompetitionVehiclesListingSectionFiltersGroups.js'
import {KM0_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './km0VehiclesListingSectionFiltersGroups.js'
import {NEW_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './newVehiclesListingSectionFiltersGroups.js'
import {NO_LICENSE_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './noLicenseVehiclesListingSectionFiltersGroups.js'
import {RENTING_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './rentingVehiclesListingSectionFiltersGroups.js'
import {SECOND_HAND_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './secondHandVehiclesListingSectionFiltersGroups.js'
import {VANS_AND_COMMERCIAL_VEHICLES_LISTING_SECTION_FILTERS_GROUPS} from './vansAndCommercialVehiclesListingSectionFiltersGroups.js'

export const FILTERS_GROUPS_BY_LISTING_SECTION_ID = {
  [String(LISTING_SECTION_IDS.ALL_VEHICLES)]: ALL_VEHICLES_LISTING_SECTION_FILTERS_GROUPS,
  [String(LISTING_SECTION_IDS.AUTOCARAVANS_AND_TRAILERS_VEHICLES)]:
    AUTOCARAVANS_AND_TRAILERS_VEHICLES_LISTING_SECTION_FILTERS_GROUPS,
  [String(LISTING_SECTION_IDS.CLASSIC_AND_COMPETITION_VEHICLES)]:
    CLASSIC_AND_COMPETITION_VEHICLES_LISTING_SECTION_FILTERS_GROUPS,
  [String(LISTING_SECTION_IDS.KM0_VEHICLES)]: KM0_VEHICLES_LISTING_SECTION_FILTERS_GROUPS,
  [String(LISTING_SECTION_IDS.NEW_VEHICLES)]: NEW_VEHICLES_LISTING_SECTION_FILTERS_GROUPS,
  [String(LISTING_SECTION_IDS.NO_LICENSE_VEHICLES)]: NO_LICENSE_VEHICLES_LISTING_SECTION_FILTERS_GROUPS,
  [String(LISTING_SECTION_IDS.RENTING_VEHICLES)]: RENTING_VEHICLES_LISTING_SECTION_FILTERS_GROUPS,
  [String(LISTING_SECTION_IDS.SECOND_HAND_VEHICLES)]: SECOND_HAND_VEHICLES_LISTING_SECTION_FILTERS_GROUPS,
  [String(LISTING_SECTION_IDS.VANS_AND_COMMERCIAL_VEHICLES)]:
    VANS_AND_COMMERCIAL_VEHICLES_LISTING_SECTION_FILTERS_GROUPS
}

// Define only the filters groups that are different from the common ones
export const FILTERS_GROUPS = {...sharedFiltersGroups}

// Do not redefine the filters groups ids that are already defined in the common ones
export const FILTERS_GROUPS_IDS = {...sharedFiltersGroupsIds}

// Define only the filters by groups ids that are different from the common ones
export const FILTERS_BY_GROUPS_IDS = {...sharedFiltersByGroupsIds}
